/**
 * @file Re-exports the InvestmentSteps component.
 */
import InvestmentSteps from "./InvestmentSteps";

export default InvestmentSteps;
